export class ViewApplicationDetailsRcConstants {
    static STEP_TITLE = "Details";
    static DESCRIPTION_LBL = "Description";
    static TYPE_LBL = "Application type";
    static DESCRIPTION_CTRL = "description";
    static TYPE_CTRL = "type";
    static APPLICATION_PLACE_HOLDER = "Application place holder";
}
